import styled from 'styled-components';
import { body1, body2, header1, header2, header5, header6, link, secondaryLink } from '@westwing/ui-kit/typography';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { HybridLink } from 'AppShell/RoutingHelper';

export const StyledHeader = styled.header`
    display: flex;
`;
export const StyledHeaderIcon = styled.span`
    flex: 0 0 auto;

    svg {
        width: 50px;
        height: 50px;
    }
    margin: -13px 0 0 -15px;
    ${forDesktop`
        margin-top: -10px;
    `}
`;

export const StyledHeaderCentered = styled(StyledHeader)`
    justify-content: center;
    text-align: center;
    ${forDesktop`
        justify-content: flex-start;
        text-align: left;
    `}
`;

const StyledHeaderText = styled.h3`
    word-break: break-word;
    color: ${({ theme }) => theme.colors.charcoal100};
    margin: 0;
`;

export const StyledPageTitle = styled(StyledHeaderText)`
    ${header1}
    ${forDesktop`
        ${header2}
    `}
`;

export const StyledModalTitle = styled(StyledHeaderText)`
    ${header6}
    ${forDesktop`
        ${header5}
    `}
`;

export const StyledForm = styled.form`
    margin: 0;
`;

export const StyledParagraph = styled.p`
    ${body2}
    color: ${({ theme }) => theme.colors.charcoal100};
    margin: 0;
    .ww-link {
        color: ${({ theme }) => theme.colors.turquoise100};
    }
`;

export const StyledFieldset = styled.fieldset`
    border: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    > *,
    > ${StyledParagraph} {
        margin-bottom: 20px;
    }
`;

export const StyledModalParagraph = styled(StyledParagraph)`
    ${body2}
    ${forDesktop`
        ${body1}
    `}
`;

export const StyledParagraphCentered = styled(StyledParagraph)`
    text-align: center;
    ${forDesktop`
        text-align: inherit;
    `}
`;

export const StyledModalContent = styled.div`
    padding-top: 22px;
`;

export const StyledPageContent = styled.div`
    margin-top: 22px;
`;

export const StyledListItem = styled.li`
    margin: 20px 0;
`;

export const StyledNumberedListItem = styled.li`
    list-style-type: number;
    list-style-position: inside;
    margin: 6px 0;
`;

export const StyledLink = styled(HybridLink)`
    ${link}
`;

export const StyledSecondaryLink = styled(HybridLink)`
    ${secondaryLink}
    color: ${({ theme }) => theme.colors.charcoal100};
`;

export const StyledLinkButton = styled.button`
    all: unset;
    ${secondaryLink}
    color: ${({ theme }) => theme.colors.charcoal100};
`;

// TODO: Find a better way here. For now it's meant for showcasing only
export const StyledModalFormActions = styled.div`
    width: 100%;
    margin: 0 auto;
`;
export const StyledFormActions = styled(StyledModalFormActions)`
    margin: 16px auto 0;
    ${forDesktop`
        max-width: 355px;
    `}
`;
